<mat-dialog-content>
    <h2>{{ data.title }}</h2>
    <table>
        <tbody>
            <tr>
                <td style="width:20%" >
                    <i class="fa-solid fa-triangle-exclamation" style="font-size: 60px; color:#b32318;"></i>
                </td>
                <td style="width:80%">{{ data.message }}</td>
            </tr>
        </tbody>
    </table>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 20px;" >
    <button mat-button class="btn-cancel" (click)="closeModal()"> {{ 'COMMON_BTN_OK' | translate }} </button>
</mat-dialog-actions>